// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import HappyScroll from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'wowjs/css/libs/animate.css'
import './mixin'
import './mixin/jsApi'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import ch from './assets/languages/ch'
import en from './assets/languages/en'
const i18n = new VueI18n({
  locale: !localStorage.getItem("lang")
    ? "ch"
    : localStorage.getItem("lang"),
  messages: {
    'ch': ch,  // 本地资源文件，配2个语言，中文&英文，src下根据个人情况放置
    'en': en
  },
  silentTranslationWarn: true
});

import waicTabs from '@/components/tabs'
import waicBanner from '@/components/banner'
import selectTitle from '@/components/select-title'
Vue.component('waic-tabs', waicTabs)
Vue.component('waic-banner', waicBanner)
Vue.component('select-title', selectTitle)

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(HappyScroll)
Vue.prototype.i18n = i18n;

Vue.prototype.$ch = (v) => ch[v]
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})
router.beforeEach((to, from, next) => {
  if (to.name !== from.name) {
    // document.documentElement.scrollTop = document.body.scrollTop = 0;
    // window.scrollTo(0, 0);
    store.commit('clearSuccessNum');
  }
  next()
})

router.afterEach((to, from, next) => {
  document.documentElement.scrollTop = document.body.scrollTop = 0;
  window.scrollTo(0, 0);
  Vue.prototype.$jsAPI('page', 'Common_pageView', { page_duration: 1 })
})


// WEBPACK FOOTER //
// ./src/main.js